import React, { useRef } from "react";
import { Link } from "@quintype/components";
import { func, array, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { differenceInHours } from "date-fns";

import TopArrowContainer from "../../../atoms/TopArrowContainer";
import PublishedAt from "../../../atoms/PublishedAt";
import More from "../../../atoms/More";

import { useOuterClickNotifier } from "../../../utils/utils";
import { staticTexts } from "../../../utils/Translate";

import "./notifications.m.css";

const notificationEvent = (notificationTitle, toggleNotifications) => {
  toggleNotifications();
};

const Notifications = ({ closeView, notifications, lang, toggleNotifications }) => {
  const viewRef = useRef(null);

  useOuterClickNotifier(closeView, viewRef);
  const latestNotifications =
    notifications.length > 0
      ? notifications.filter(
          (item) => differenceInHours(new Date(), new Date(item.created_time + " GMT".toLocaleString())) <= 48
        )
      : [];

  return (
    <div styleName="notifications-dropdown" ref={viewRef}>
      <TopArrowContainer className="notifications" closeView={closeView}>
        {latestNotifications.length > 0 ? (
          <ul className="notifications-list">
            {latestNotifications.slice(0, 3).map((item, index) => {
              const sentTime = item.created_time + " GMT";
              return (
                <li className="notifications-list-item" key={index}>
                  {item.notification_url !== "https://www.prothomalo.com" ? (
                    <Link aria-label="Notification title" href={item.notification_url}>
                      <div
                        className="notification-title"
                        onClick={() => notificationEvent(item.notification_title, toggleNotifications)}
                      >
                        {item.notification_title}
                      </div>
                      <PublishedAt date={new Date(sentTime.toLocaleString())} className="notification-story-date" />
                    </Link>
                  ) : (
                    <div>
                      <div
                        className="notification-title"
                        onClick={() => notificationEvent(item.notification_title, toggleNotifications)}
                      >
                        {item.notification_title}
                      </div>
                      <PublishedAt date={new Date(sentTime.toLocaleString())} className="notification-story-date" />
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="no-notifications">{staticTexts(lang).noNotifications}</div>
        )}
        {latestNotifications.length > 3 && (
          <Link aria-label="notification link" href="/notifications" styleName={`load-more-view`}>
            <More type="load-more" text={staticTexts(lang).more} onClick={toggleNotifications} />
          </Link>
        )}
      </TopArrowContainer>
    </div>
  );
};

Notifications.propTypes = {
  closeView: func,
  lang: string,
  notifications: array,
  toggleNotifications: func,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(Notifications);
